export default class ViewportObserver {
  constructor({root = null, threshold = 0} = {}) {
    this.__observed_elements = new Map()
    this.__last_entries = new Map()

    this.observer = new IntersectionObserver(this._handleIntersect.bind(this), {
      root,
      threshold,
    })
  }

  _handleIntersect(entries) {
    for (const entry of entries) {
      const callback = this.__observed_elements.get(entry.target)
      this.__last_entries.set(entry.target, entry)

      if (callback) {
        const position = this._getVisibilityPosition(entry)
        callback({
          isVisible: entry.isIntersecting,
          position, // visible | above | below
          entry,
        })
      }
    }
  }

  _getVisibilityPosition(entry) {
    const el_rect = entry.boundingClientRect
    const root_rect = entry.rootBounds
    if (!root_rect || entry.isIntersecting) return 'visible'

    if (el_rect.bottom <= root_rect.top) return 'above'
    if (el_rect.top >= root_rect.bottom) return 'below'
    return null
  }

  observe(element, callback) {
    if (typeof callback !== 'function') return

    this.__observed_elements.set(element, callback)
    this.__last_entries.set(element, null)
    this.observer.observe(element)
  }

  observeMany(elements, callback) {
    elements.forEach(el => this.observe(el, callback))
  }

  unobserve(element) {
    this.__observed_elements.delete(element)
    this.observer.unobserve(element)
  }

  unobserveAll(){
    for (const element of this.__observed_elements.keys()) {
      this.unobserve(element)
    }
  }

  disconnect() {
    this.__observed_elements.clear()
    this.__last_entries.clear()
    this.observer.disconnect()
  }

  getAllVisible() {
    const result = []
    for (const entry of this.__last_entries.values()) {
      if (!entry?.isIntersecting) continue
      result.push(entry.target)
    }
    return result
  }
}